import type { IconSvgObject } from './types';

const Tablet01Icon: IconSvgObject = [
  ["path", { d: "M17.5 2H6.5C4.84315 2 3.5 3.34315 3.5 5V19C3.5 20.6569 4.84315 22 6.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V5C20.5 3.34315 19.1569 2 17.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.125 19H12M12.25 19C12.25 19.1381 12.1381 19.25 12 19.25C11.8619 19.25 11.75 19.1381 11.75 19C11.75 18.8619 11.8619 18.75 12 18.75C12.1381 18.75 12.25 18.8619 12.25 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Tablet01Icon;
